export default {
    template_html: {
        logged_page: true,
        home_redirect: false,
        header_default_enable: true,
    },
    loaded: false
};